"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var cloudinary_service_1 = require("./cloudinary.service");
var cloudinary_transformation_directive_1 = require("./cloudinary-transformation.directive");
var CloudinaryBackgroundImageDirective = /** @class */ (function () {
    function CloudinaryBackgroundImageDirective(renderer, el, cloudinary) {
        this.renderer = renderer;
        this.el = el;
        this.cloudinary = cloudinary;
    }
    CloudinaryBackgroundImageDirective.prototype.isBrowser = function () {
        return typeof window !== 'undefined';
    };
    CloudinaryBackgroundImageDirective.prototype.ngAfterViewInit = function () {
        if (this.isBrowser()) {
            var nativeElement = this.el.nativeElement;
            var options = this.cloudinary.toCloudinaryAttributes(nativeElement.attributes, this.transformations);
            var imageUrl = this.cloudinary.url(this.clBackgroundImage, options);
            this.renderer.setStyle(nativeElement, 'background-image', "url('" + imageUrl + "')");
            this.renderer.setStyle(nativeElement, 'background-repeat', 'no-repeat');
            this.renderer.setStyle(nativeElement, 'background-position', 'center');
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], CloudinaryBackgroundImageDirective.prototype, "clBackgroundImage", void 0);
    __decorate([
        core_1.ContentChildren(cloudinary_transformation_directive_1.CloudinaryTransformationDirective),
        __metadata("design:type", core_1.QueryList)
    ], CloudinaryBackgroundImageDirective.prototype, "transformations", void 0);
    CloudinaryBackgroundImageDirective = __decorate([
        core_1.Directive({
            selector: '[clBackgroundImage]'
        }),
        __metadata("design:paramtypes", [core_1.Renderer2, core_1.ElementRef, cloudinary_service_1.Cloudinary])
    ], CloudinaryBackgroundImageDirective);
    return CloudinaryBackgroundImageDirective;
}());
exports.CloudinaryBackgroundImageDirective = CloudinaryBackgroundImageDirective;
//# sourceMappingURL=cloudinary-background-image.directive.js.map